import React from "react";
import "../../assets/css/cta.css";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

export default function CTA() {
  return (
    <section className="cta">

      <div className="cta-wrapper">

        <motion.div
          className="cta-box"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >

          <h2>
            Let’s Plan Your <span>Trip Today!</span>
          </h2>

          <p>
            Travel more, worry less — Trip Word is here for you ✈️
          </p>

          {/* ✅ SINGLE container only */}
          <div className="cta-buttons">

              <NavLink to="/services" className="primary">
                Start Planning
              </NavLink>

           
           

          </div>

        </motion.div>

      </div>

    </section>
  );
}